import { render, staticRenderFns } from "./Regist.Edit.vue?vue&type=template&id=1dbd7e8b&"
import script from "./Regist.Edit.vue?vue&type=script&lang=js&"
export * from "./Regist.Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports